module.exports = __webpack_public_path__ + "img/pic-radio.3716b49a.png";